import { useEffect } from "react";

const usePageTitle = (title: string) => {
  useEffect(() => {
    window.document.title = title;
  }, [title]);
};

export { usePageTitle };
